import { z } from 'zod';
import { CreditResolutionMethod } from '../../enums/crew.js';
import { calculatedBeforeClaimSubmission, financialSection, } from './calculatedOrder.js';
import { claimLineItem } from './claimLineItem.js';
import { storeOrderLineItem } from './lineItem.js';
const ledgerLineItem = claimLineItem
    .pick({
    id: true,
    quantity: true,
    unitPrice: true,
    unitTax: true,
    amount: true,
})
    .merge(storeOrderLineItem.pick({
    name: true,
    sku: true,
    imgUrl: true,
    optionsFromPlatform: true,
}));
const financialSectionLedger = financialSection
    .omit({
    lineItems: true,
})
    .merge(z.object({
    lineItems: z.array(ledgerLineItem),
}));
export const claimLedger = calculatedBeforeClaimSubmission
    .omit({
    paymentIntent: true,
    lineItemApplications: true,
    credits: true,
    deductions: true,
})
    .extend({
    benefit: z.number(),
    credits: financialSectionLedger,
    deductions: financialSectionLedger,
    totals: z.array(z.object({
        label: z.string(),
        amount: z.number(),
        type: z.union([
            z.literal(`${CreditResolutionMethod.giftCard}`),
            z.literal(`${CreditResolutionMethod.refund}`),
        ]),
    })),
});
//# sourceMappingURL=claimLedger.js.map